module.exports = __webpack_public_path__ + "media/images/flags/4x3/bhs-929b1134cad80cc85d12c4fbebab287b.svg";